export const VEHICLE_LABELS = {
  tricycle: 'Tricycle', jeepney: 'Jeepney', taxi: 'Taxi',
  'ride-share': 'Ride-share', van: 'Van', bus: 'Bus', other: 'Other',
};

export const VEHICLE_ICONS = {
  tricycle: 'bike', jeepney: 'bus', taxi: 'car-taxi-front',
  'ride-share': 'car', van: 'truck', bus: 'bus-front', other: 'navigation',
};

// Build a pre-filled SMS deep link so the user can send a text from their own
// Messages app (free — no SMS gateway cost). Works cross-platform via "?&body=".
export function smsHref(number, body) {
  const n = (number || '').replace(/[^\d+]/g, '');
  return `sms:${n}?&body=${encodeURIComponent(body || '')}`;
}


export function timeAgo(iso, now = Date.now()) {
  if (!iso) return '—';
  const t = new Date(iso).getTime();
  const s = Math.max(0, Math.floor((now - t) / 1000));
  if (s < 5) return 'just now';
  if (s < 60) return `${s} seconds ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} minute${m > 1 ? 's' : ''} ago`;
  const h = Math.floor(m / 60);
  return `${h} hour${h > 1 ? 's' : ''} ago`;
}

export function elapsed(startIso, now = Date.now()) {
  if (!startIso) return '00:00';
  const s = Math.max(0, Math.floor((now - new Date(startIso).getTime()) / 1000));
  const mm = String(Math.floor(s / 60)).padStart(2, '0');
  const ss = String(s % 60).padStart(2, '0');
  const hh = Math.floor(s / 3600);
  if (hh > 0) return `${String(hh).padStart(2, '0')}:${mm}:${ss}`;
  return `${mm}:${ss}`;
}

export function fmtDate(iso) {
  if (!iso) return '';
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
}
